define('view/controller/booking/datetime/flexible-weekly/TimeFlexibleWeeklyView',['require','view/controller/booking/datetime/flexible/TimeFlexibleView','view/controller/booking/datetime/flexible-weekly/TimeFlexibleWeeklyDayView'],function (require) {

    var TimeFlexibleView = require('view/controller/booking/datetime/flexible/TimeFlexibleView');
    var TimeFlexibleWeeklyDayView = require('view/controller/booking/datetime/flexible-weekly/TimeFlexibleWeeklyDayView');

    /**
     * Flexible weekly timeline view (container)
     *
     * @class TimeFlexibleWeeklyView
     */
    return TimeFlexibleView.extend({

        template: '#time_flexible_weekly_view',

        childViewContainer: '#sb_time_flexible_weekly_container',
        childView: TimeFlexibleWeeklyDayView,

        childViewOptions: function (model, index) {
            return _.extend(TimeFlexibleView.prototype.childViewOptions.apply(this, arguments), {
                isDayOff : this._calendarCollection.isDayOff(model.get('date'))
            });
        },

        _daysDiff: 7,

        _updateCollection: function () {
            this.collection = this._timeCollection.getCollectionGroupedByDay();
        },

        getTimeCollection: function () {
            return this._timeCollection;
        },

        getCalendarCollection: function () {
            return this._calendarCollection;
        },

        serializeData: function () {
            var result = TimeFlexibleView.prototype.serializeData.apply(this);

            if (!this.collection) {
                return result;
            }

            var firstDay = this.collection.first();
            var lastDay = this.collection.last();

            result.available_time = [];
            if (firstDay) {
                var collection = firstDay.get('collection');
                collection.each(function (model) {
                    result.available_time.push(model.toJSON());
                });

                result.from = firstDay.get('date');
            }
            if (lastDay) {
                result.to = lastDay.get('date');
            }

            var selectedDates = this.getOption('selectedDates');
            var dayOffs = [];

            for(var i = 0; i<selectedDates.length; i++){
                dayOffs[selectedDates[i]] = this.getCalendarCollection().isDayOff(selectedDates[i]);
            }
            //result.selected_dates = selectedDates;
            //result.dayoff_list = dayOffs;
            result.wl_available_dates = _.filter(_.keys(dayOffs), function(n){
                return !dayOffs[n];
            });
            result.show_wl_slots = !_.every(_.values(dayOffs), function(num) { return num; });

            //console.log(result);

            result.time_diff = this.getOption('clientTimeZone').get('time_diff');
            result.is_empty = this.isEmptyDayCollection();

            return result;
        },

        isEmptyDayCollection: function () {
            if (!this.getOption('clientTimeZone').isReady()) {
                return true;
            }

            return this._timeCollection.isEmptyDayCollection();
        },

        filter: function (child, index, collection) {
            if (!this.getOption('clientTimeZone').isReady()) {
                return false;
            }

            return !this._timeCollection.isEmptyDayCollection();
        }

    });

});
